<app-lesson-observation-view *ngIf="isReady && !isEdit" [data]="data" (edit)="onEdit()"></app-lesson-observation-view>
<app-lesson-observation-edit *ngIf="isReady && isEdit && !onClose" [data]="data"></app-lesson-observation-edit>
<app-lesson-observation-edit *ngIf="isReady && isEdit && onClose" [data]="data" (close)="onClose($event)"></app-lesson-observation-edit>
